import React from "react";
import { Helmet } from "react-helmet-async";

type SEOProps = {
  title: string;
  description: string;
  name: string;
  type: string;
  url: string;
};

const SearchEngineOptimizationProvider: React.FC<SEOProps> = ({
  title,
  description,
  name,
  type,
  url,
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      {/* Standard metadata tags */}
      <meta name="description" content={description} data-react-helmet="true" />
      <meta name="copyright" content={name} data-react-helmet="true" />
      {/* End standard metadata tags */}
      {/* Facebook tags */}
      <meta property="og:title" content={title} data-react-helmet="true" />
      <meta property="og:type" content={type} data-react-helmet="true" />
      <meta property="og:url" content={url} data-react-helmet="true" />
      {/* End Facebook tags */}
    </Helmet>
  );
};

export { SearchEngineOptimizationProvider };
